import { render, staticRenderFns } from "./Image-Zoom.vue?vue&type=template&id=fc8be196&scoped=true&"
import script from "./Image-Zoom.vue?vue&type=script&lang=js&"
export * from "./Image-Zoom.vue?vue&type=script&lang=js&"
import style0 from "./Image-Zoom.vue?vue&type=style&index=0&id=fc8be196&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8be196",
  null
  
)

export default component.exports